export default "__VITE_ASSET__e1f80978__"